import React, { useEffect, useState } from "react";
import TitleText, { TitleTextSize } from "../../../components/TitleText";
import Paragraph, { ParagraphSize } from "../../../components/Paragraph";
import styles from "./FAQ.module.css";
import AssetsPack from "../../../util/AssetsPack";
import { useTranslation } from "react-i18next";
import QuestionComponent from "./QuestionComponent";
import { faqCards, faqListData } from "../../../util/CollectionData";
import { FAQType } from "./FAQType";
import { SupportEmail } from "../../../util/Constant";
import DropCardView from "../../../components/DropCardView";
import ImageComponent from "../../../components/ImageComponent";

interface FaqItem {
  type: string;
  question: string;
  answer: string;
}

const FAQ = () => {
  const [selectedCard, setSelectedCard] = useState(faqCards[0].label);
  const [selectedList, setSelectedList] = useState<FaqItem[][]>([[], []]);

  const { t } = useTranslation();

  const onCardClick = (label: any) => {
    setSelectedCard(label.label);

    const filteredList =
      label.type == FAQType.All
        ? faqList
        : faqList.filter((item) => item.type === label.type);

    setFaqList(filteredList);
  };

  const faqList = faqListData;

  useEffect(() => {
    if (faqCards.length > 0) {
      setSelectedCard(faqCards[0].label);
      onCardClick(faqCards[0]);
    }
  }, []);

  const setFaqList = (filteredList: FaqItem[]) => {
    const midFilteredIndex = Math.ceil(filteredList.length / 2);
    setSelectedList([
      filteredList.slice(0, midFilteredIndex),
      filteredList.slice(midFilteredIndex),
    ]);
  };

  const renderFaqHeader = () => (
    <div>
      <TitleText size={TitleTextSize.heading3}>
        {t("joker_support.frequently_question")}
      </TitleText>
      <div className={styles["description-container"]}>
        <ImageComponent src={AssetsPack.icons.CHAT.default} alt="Chat Icon" />
        <Paragraph
          size={ParagraphSize.paragraph2}
          classNameStyle={styles["description-text"]}
        >
          {t("joker_support.still_need_help")}{" "}
          <a href={SupportEmail} className={styles["chat-us"]}>
            {t("joker_support.chat_to_us")}
          </a>
        </Paragraph>
      </div>
    </div>
  );

  const renderFaqGameCardSection = () => (
    <div className={styles["game-card"]}>
      <DropCardView
        cards={faqCards}
        selectedCard={selectedCard}
        onCardClick={onCardClick}
      />
    </div>
  );

  const renderFaqColumns = () => (
    <div className={styles["faq-container"]}>
      {selectedList.map((column, colIndex) => (
        <div key={colIndex} className={styles["column-layout"]}>
          {column.map((item, index) => (
            <QuestionComponent
              key={`${colIndex}-${index}`}
              question={item.question}
              answer={item.answer}
            />
          ))}
        </div>
      ))}
    </div>
  );

  return (
    <div className={styles["main-container"]}>
      {renderFaqHeader()}
      {renderFaqGameCardSection()}
      {renderFaqColumns()}
    </div>
  );
};

export default FAQ;
